import React from "react";
import {Menu} from "antd";
import theme from "../theme";
import {getMenuItemsByRoleAndEntity} from "./MenuItems";
import {useUserRole} from "../utils/userSessionUtils";
import {useSelector} from "react-redux";
import {useLocation} from "react-router-dom";

const AfSidebarMenu = () => {
    const role = useUserRole();
    const auth = useSelector((state) => state.auth || {});
    const entity = auth.user?.entityId || 0;
    const group = auth.user?.group || "";
    const location = useLocation();
    const collapsed = useSelector((state) => state.sidebar.collapsed);

    const linkColor = collapsed ? '#000000' : theme.colors.card;
    const menuItems = getMenuItemsByRoleAndEntity(role, entity, linkColor, group);
    
    // Encontrar el key del item seleccionado y su parent
    let selectedKey = null;
    let openKey = null;
    
    menuItems.forEach(item => {
        if (item.path === location.pathname) {
            selectedKey = item.key;
        }
        if (item.children) {
            item.children.forEach(child => {
                if (child.path === location.pathname) {
                    selectedKey = child.key;
                    openKey = item.key;
                }
            });
        }
    });
    
    return (
        <Menu
            mode="inline"
            selectedKeys={selectedKey ? [selectedKey] : []}
            defaultOpenKeys={openKey ? [openKey] : []}
            items={menuItems.map(item => ({
                key: item.key,
                path: item.path,
                icon: item.icon,
                label: item.label,
                children: item.children,
            }))}
            style={{
                background: theme.colors.secondary,
                color: theme.colors.card,
                marginTop: "20px",
                borderRight: "none",
            }}
            styles={{
                item: {
                    color: theme.colors.card,
                },
                submenuTitle: {
                    color: theme.colors.card,
                }
            }}
        />
    );
};

export default AfSidebarMenu;
